import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Paper, Typography, useMediaQuery, useTheme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { K1Information } from '@e3dc-react/icons'
import { UseFormReset } from 'react-hook-form'
import { ChargingCardToWallboxFormData } from './charging-card-to-wallbox-form-data'
import useModals from 'src/Hooks/useModals'
import { ChargingCardModel } from 'src/Libs/e-mobility/charging-cards'
import { WallboxModel } from '../../../wallboxes/models/wallbox-model'

const useStyles = makeStyles()(theme => ({
  alertContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    backgroundColor: theme.palette.secondary.light,
    display: 'flex',
    alignItems: 'center',
  },
  alertText: {
    color: theme.palette.grey.grey01,
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'center',
    fontWeight: 400,
  },
}))

interface ManagedModeInfoAlertProps {
  isManagedMode: boolean
  reset: UseFormReset<ChargingCardToWallboxFormData>
  chargingCards: ChargingCardModel[]
  wallboxes: WallboxModel[]
  installationId: number
}

/**
 * Component for displaying alert for managed or unmanaged mode for charging cards inside charging card link to wallboxes dialog.
 * No params required
 */
export const ManagedModeInfoAlert: React.FC<ManagedModeInfoAlertProps> = ({ isManagedMode, reset, installationId, chargingCards, wallboxes }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const { openUnlinkChargingCardsDialog } = useModals()

  return (
    <Paper component="div" className={classes.alertContainer} sx={{ flexDirection: isMobile ? 'column' : 'row' }}>
      <K1Information sx={{ marginBottom: isMobile ? theme.spacing(2) : 0 }} />
      <Box width={'100%'}>
        {isManagedMode ? (
          <Typography className={classes.alertText}>{t('emobility.chargingCards.managed-mode-alert-text')}</Typography>
        ) : (
          <Typography className={classes.alertText}>{t('emobility.chargingCards.unmanaged-mode-alert-text')}</Typography>
        )}
      </Box>
      {isManagedMode && (
        <Button
          variant="outlined"
          color="inherit"
          sx={{ minWidth: 'max-content', marginTop: isMobile ? theme.spacing(2) : 0 }}
          onClick={() => openUnlinkChargingCardsDialog({ reset, installationId, chargingCards, wallboxes })}
        >
          {t('emobility.chargingCards.remove-all-links-button-text')}
        </Button>
      )}
    </Paper>
  )
}
